import { Capacitor } from '@capacitor/core'
import { Intercom } from '@capacitor-community/intercom'
import { isPlatform } from '@ionic/react'

import loadIntercomWeb from '../loadIntercomWeb'

export const initIntercom = (customer: CustomerData, phoneCharacteristics: PhoneCharacteristics, locale: string) => {
  const intercomAccesses = customer.allAccesses.filter((a) => a.custom_name && !a.custom_name.includes('transportörsdörr')).reverse()

  if (Capacitor.isNativePlatform()) {
    Intercom.registerIdentifiedUser({ userId: '', email: customer.customer.email })

    Intercom.updateUser({
      name: `${customer.customer.name} ${customer.customer.surname || ''}`,
      email: customer.customer.email,
      phone: customer.customer.phone,
      languageOverride: locale,
      customAttributes: {
        Locks: JSON.stringify(customer.allAccesses.map((a) => a.custom_name)),
        Construction: customer.customer.construction,
        Organization: customer.customer.organization,
        'Main Organization': customer.mainOrganization,
        'App Version': phoneCharacteristics.appVersion,
        companies: intercomAccesses.map((a) => ({
          id: a.custom_name,
          name: a.custom_name,
        })),
      },
    })

    if (!customer.customer.shouldHideIntercom) {
      setTimeout(() => {
        Intercom.displayLauncher()

        const [ionTabButton] = document.getElementsByTagName('ion-tab-button') as any

        let height = ionTabButton?.clientHeight || 0

        if (height) {
          if (isPlatform('android')) height *= 3

          Intercom.setBottomPadding({ value: String(Math.round(height)) })
        }
      }, 200)
    }
  } else {
    loadIntercomWeb()

    window.Intercom?.('update', {
      ...window.intercomSettings,
      hide_default_launcher: Capacitor.isNativePlatform() || customer.customer.shouldHideIntercom,
      'App Version': phoneCharacteristics.appVersion,
      email: customer.customer.email,
      name: `${customer.customer.name} ${customer.customer.surname || ''}`,
      phone: customer.customer.phone,
      Locks: JSON.stringify(customer.allAccesses.map((a) => a.custom_name)),
      Construction: customer.customer.construction,
      Organization: customer.customer.organization,
      'Main Organization': customer.mainOrganization,
      companies: intercomAccesses.map((a) => ({
        id: a.custom_name,
        name: a.custom_name,
      })),
      language_override: locale,
    })
  }
}

export const logEvent = (name: string, data?: any) => {
  if (Capacitor.isNativePlatform()) {
    Intercom.logEvent({ name, data })
  } else {
    window.Intercom?.('trackEvent', name, data)
  }
}

export const setIntercomLocale = (locale: string) => {
  if (Capacitor.isNativePlatform()) {
    Intercom.updateUser({ customAttributes: { languageOverride: locale } })
  } else {
    window.Intercom?.('update', { language_override: locale })
  }
}

export const logoutIntercom = () => {
  if (Capacitor.isNativePlatform()) {
    Intercom.logout()
  } else {
    window.Intercom?.('shutdown')
  }
}
